export const adminCommerceMessages = {
  'zh-CN': {
    excluded:
      '排除记录：无付款时间 {missing}，晚于或等于快照 {future}，金额异常 {amount}，币种异常 {currency}',
    nominalAverage: '每单平均标价',
    gift: '赠送激活，不计现金收入',

    deleteUser: '删除空账户',
    deleteHint: '仅删除无依赖的免费网页账户；支付、会员及审计历史会阻止删除。',
    confirmDelete: '我确认删除此空账户',
    blocked: '无法删除：{reason}',
    SELF: '当前账户',
    LAST_ADMIN: '最后管理员',
    NON_WEB: '非网页账户',
    MEMBERSHIP_HISTORY: '存在会员历史',
    DEPENDENCIES: '存在关联记录',
    cdkeys: '终身兑换码',
    count: '生成数量',
    batch: '批次名称',
    prefix: '前缀（可选）',
    generate: '生成',
    newRequest: '开始新请求',
    code: '代码',
    usedBy: '使用者',
    usedAt: '使用时间',
    disable: '禁用',
    exportHint: '导出当前批次与状态筛选的全部结果（不是本页）；文件包含敏感代码，请妥善保存。',
    ACTIVE: '可用',
    USED: '已使用',
    DISABLED: '已禁用',
    EXPIRED: '已过期',
    revenue: '收入与人工开通统计',
    revenueHint:
      '北京时间月界；近30日为滚动720小时。按 paidAt，截至同一快照时间，排除未来及无效记录。币种分别统计；人工标价及兑换码不计入现金收入。',
    allTime: '累计',
    month: '本月',
    last30Days: '近30日',
    cash: 'CCPayment 实际支付',
    manual: '人工开通标价（非到账）',
    payers: '付费用户数',
    orderCount: '订单数',
    average: '每单均额',
    plan: '套餐',
    snapshot: '统计时点',
  },
  'zh-TW': {
    excluded:
      '排除紀錄：無付款時間 {missing}，晚於或等於快照 {future}，金額異常 {amount}，幣別異常 {currency}',
    nominalAverage: '每單平均標價',
    gift: '贈送啟用，不計現金收入',

    deleteUser: '刪除空帳戶',
    deleteHint: '僅刪除無關聯的免費網頁帳戶；付款、會員及稽核歷史會阻止刪除。',
    confirmDelete: '我確認刪除此空帳戶',
    blocked: '無法刪除：{reason}',
    SELF: '目前帳戶',
    LAST_ADMIN: '最後管理員',
    NON_WEB: '非網頁帳戶',
    MEMBERSHIP_HISTORY: '存在會員歷史',
    DEPENDENCIES: '存在關聯紀錄',
    cdkeys: '終身兌換碼',
    count: '產生數量',
    batch: '批次名稱',
    prefix: '前綴（選填）',
    generate: '產生',
    newRequest: '開始新請求',
    code: '代碼',
    usedBy: '使用者',
    usedAt: '使用時間',
    disable: '停用',
    exportHint: '匯出目前批次與狀態篩選的全部結果（不是本頁）；檔案含敏感代碼，請妥善保存。',
    ACTIVE: '可用',
    USED: '已使用',
    DISABLED: '已停用',
    EXPIRED: '已過期',
    revenue: '收入與人工開通統計',
    revenueHint:
      '北京時間月界；近30日為滾動720小時。按 paidAt，截至同一快照時間，排除未來及無效紀錄。幣別分別統計；人工標價及兌換碼不計入現金收入。',
    allTime: '累計',
    month: '本月',
    last30Days: '近30日',
    cash: 'CCPayment 實際支付',
    manual: '人工開通標價（非入帳）',
    payers: '付費使用者數',
    orderCount: '訂單數',
    average: '每單均額',
    plan: '方案',
    snapshot: '統計時點',
  },
  en: {
    excluded:
      'Excluded: missing paidAt {missing}, at/after snapshot {future}, invalid amount {amount}, invalid currency {currency}',
    nominalAverage: 'Average nominal value per order',
    gift: 'Gift activations; excluded from cash receipts',

    deleteUser: 'Delete empty account',
    deleteHint:
      'Only dependency-free free web accounts can be deleted. Payment, membership and audit history prevent deletion.',
    confirmDelete: 'I confirm deletion of this empty account',
    blocked: 'Deletion blocked: {reason}',
    SELF: 'Current account',
    LAST_ADMIN: 'Last administrator',
    NON_WEB: 'Non-web account',
    MEMBERSHIP_HISTORY: 'Membership history exists',
    DEPENDENCIES: 'Related records exist',
    cdkeys: 'Lifetime redemption codes',
    count: 'Number to generate',
    batch: 'Batch name',
    prefix: 'Prefix (optional)',
    generate: 'Generate',
    newRequest: 'Start a new request',
    code: 'Code',
    usedBy: 'Used by',
    usedAt: 'Used at',
    disable: 'Disable',
    exportHint:
      'Export all results matching the current batch and status, not just this page. The file contains sensitive codes.',
    ACTIVE: 'Active',
    USED: 'Used',
    DISABLED: 'Disabled',
    EXPIRED: 'Expired',
    revenue: 'Receipts and manual grants',
    revenueHint:
      'Month boundaries use Asia/Shanghai; the last 30 days means rolling 720 hours. Uses paidAt and one snapshot cutoff, excluding future/invalid records. Currencies remain separate; manual face values and redemption codes are not cash receipts.',
    allTime: 'All time',
    month: 'This month',
    last30Days: 'Last 30 days',
    cash: 'CCPayment actual payments',
    manual: 'Manual grant face value (not receipts)',
    payers: 'Paying users',
    orderCount: 'Orders',
    average: 'Average per order',
    plan: 'Plan',
    snapshot: 'Snapshot',
  },
  ja: {
    excluded:
      '除外：支払日時なし {missing}、集計時点以降 {future}、無効な金額 {amount}、無効な通貨 {currency}',
    nominalAverage: '注文平均額面',
    gift: '無償付与：入金に含めません',

    deleteUser: '空のアカウントを削除',
    deleteHint:
      '関連データのない無料 Web アカウントのみ削除できます。支払い・会員・監査履歴があれば削除できません。',
    confirmDelete: 'この空のアカウントの削除を確認します',
    blocked: '削除できません：{reason}',
    SELF: '現在のアカウント',
    LAST_ADMIN: '最後の管理者',
    NON_WEB: 'Web 以外のアカウント',
    MEMBERSHIP_HISTORY: '会員履歴あり',
    DEPENDENCIES: '関連レコードあり',
    cdkeys: '永久会員引換コード',
    count: '生成数',
    batch: 'バッチ名',
    prefix: '接頭辞（任意）',
    generate: '生成',
    newRequest: '新しいリクエスト',
    code: 'コード',
    usedBy: '使用者',
    usedAt: '使用日時',
    disable: '無効化',
    exportHint:
      '現在のバッチ・状態に一致する全件を出力します（このページのみではありません）。機密コードを安全に保管してください。',
    ACTIVE: '有効',
    USED: '使用済み',
    DISABLED: '無効',
    EXPIRED: '期限切れ',
    revenue: '入金と手動付与の統計',
    revenueHint:
      '月境界は北京時間、直近30日は720時間です。paidAt と共通の集計時点を使用し、未来・無効な記録を除外。通貨別に集計し、手動付与額・引換コードは入金に含めません。',
    allTime: '累計',
    month: '今月',
    last30Days: '直近30日',
    cash: 'CCPayment 実支払い',
    manual: '手動付与の額面（入金ではありません）',
    payers: '支払ユーザー数',
    orderCount: '注文数',
    average: '注文平均額',
    plan: 'プラン',
    snapshot: '集計時点',
  },
  ko: {
    excluded:
      '제외: paidAt 없음 {missing}, 기준 시간 이후/동일 {future}, 잘못된 금액 {amount}, 잘못된 통화 {currency}',
    nominalAverage: '주문당 평균 표시 가격',
    gift: '무료 활성화: 현금 수입에서 제외',

    deleteUser: '빈 계정 삭제',
    deleteHint:
      '연결 데이터가 없는 무료 웹 계정만 삭제할 수 있습니다. 결제·회원·감사 기록이 있으면 삭제할 수 없습니다.',
    confirmDelete: '이 빈 계정의 삭제를 확인합니다',
    blocked: '삭제 불가: {reason}',
    SELF: '현재 계정',
    LAST_ADMIN: '마지막 관리자',
    NON_WEB: '웹 계정이 아님',
    MEMBERSHIP_HISTORY: '회원 기록 있음',
    DEPENDENCIES: '연결 기록 있음',
    cdkeys: '평생 회원 교환 코드',
    count: '생성 수',
    batch: '배치 이름',
    prefix: '접두사 (선택)',
    generate: '생성',
    newRequest: '새 요청 시작',
    code: '코드',
    usedBy: '사용자',
    usedAt: '사용 시간',
    disable: '비활성화',
    exportHint:
      '현재 배치 및 상태에 일치하는 전체 결과를 내보냅니다(현재 페이지만 아님). 민감한 코드를 안전하게 보관하세요.',
    ACTIVE: '사용 가능',
    USED: '사용됨',
    DISABLED: '비활성',
    EXPIRED: '만료',
    revenue: '결제 및 수동 지급 통계',
    revenueHint:
      '월 경계는 베이징 시간, 최근 30일은 720시간입니다. paidAt 및 동일한 기준 시간을 사용하며 미래·잘못된 기록은 제외합니다. 통화는 별도 집계하며 수동 표시 가격과 교환 코드는 현금 수입이 아닙니다.',
    allTime: '전체 기간',
    month: '이번 달',
    last30Days: '최근 30일',
    cash: 'CCPayment 실제 결제',
    manual: '수동 지급 표시 가격 (입금 아님)',
    payers: '결제 사용자 수',
    orderCount: '주문 수',
    average: '주문 평균',
    plan: '요금제',
    snapshot: '기준 시간',
  },
} as const
